import apiClient from './client';

/** LLM 模拟用户合成评测用例（B8）API 客户端。 */

export interface SynthesizedCase {
  case_id: string;
  title: string;
  starting_prompt: string;
  conversation_plan: string[];
  case_type: 'qa' | 'tool_call' | 'boundary';
  expected: {
    answer_contains?: string[];
    reference?: string | null;
    expect_refuse?: boolean | null;
    expect_trigger?: boolean | null;
    expect_tool?: string[];
    rubric?: string | null;
  };
  tags: string[];
  /** 多轮模拟轨迹（user/assistant 交替） */
  trace: { role: 'user' | 'assistant'; content: string }[];
  final_excerpt: string;
}

export type SynthesizedRunStatus = 'pending' | 'running' | 'succeeded' | 'failed';

export interface SynthesizedRun {
  id: string;
  agent_id: string;
  tenant_id: string | null;
  user_id: string | null;
  status: SynthesizedRunStatus;
  params: { num_cases: number; focus?: string | null; max_turns: number };
  cases: SynthesizedCase[];
  error: string | null;
  job_id: string | null;
  suite_id: string | null;
  suite_name: string | null;
  materialized_at: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface SynthesizePayload {
  num_cases: number;
  focus?: string | null;
  max_turns?: number;
}

export interface MaterializeResult {
  suite_id: string;
  suite_name: string;
  kind: string;
  case_count: number;
  path: string;
  judge: string;
  suite: Record<string, unknown>;
}

/** 创建合成批次并异步执行，返回 run_id + job_id（进度经 job 事件流订阅）。 */
export async function synthesizeCases(
  agentId: string,
  payload: SynthesizePayload
): Promise<{ run_id: string; job_id: string; run: SynthesizedRun }> {
  const res = await apiClient.post(`/agents/${agentId}/eval/synthesize`, payload);
  return res.data;
}

/** 批次列表（新的在前，含用例详情与 materialize 落点）。 */
export async function listSynthesizedRuns(agentId: string): Promise<{ total: number; runs: SynthesizedRun[] }> {
  const res = await apiClient.get(`/agents/${agentId}/eval/synthesized`);
  return res.data;
}

/** 用例转为评测套件（goal / evolution 可绑定）。 */
export async function materializeRun(runId: string, kind = 'skill'): Promise<MaterializeResult> {
  const res = await apiClient.post(`/eval/synthesized/${runId}/materialize`, { kind });
  return res.data;
}
